/* Frequently Bought Together
 * - Fetches the recommendations-rendered section and injects it (Shopify's
 *   `recommendations` object is only populated when requested via the
 *   product-recommendations URL).
 * - Wires the checkboxes / variant selects → live total, and "Add all to bag".
 */
(() => {
  const root = document.querySelector('[data-fbt]');
  if (!root || !root.dataset.url || root.dataset.fbtBound) return;
  root.dataset.fbtBound = '1';

  // Symbol-only money (e.g. "$22.38", "€21.95") — no ISO currency codes.
  const money = (cents) => {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
    const locale = (navigator.language || 'en-CA').replace('_', '-');
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2);
    }
  };

  const variantEl = (item) => item.querySelector('select[data-fbt-variant], input[data-fbt-variant]');
  const itemPrice = (item) => {
    const el = variantEl(item);
    if (!el) return 0;
    if (el.tagName === 'SELECT') {
      const opt = el.selectedOptions[0];
      return opt ? Number(opt.dataset.price || 0) : 0;
    }
    return Number(el.dataset.price || 0);
  };
  const itemVariantId = (item) => {
    const el = variantEl(item);
    return el ? Number(el.value) : null;
  };

  const wire = (scope) => {
    const items = [...scope.querySelectorAll('[data-fbt-item]')];
    if (!items.length) return;
    const totalEl = scope.querySelector('[data-fbt-total]');
    const addBtn = scope.querySelector('[data-fbt-add]');

    const updateTotal = () => {
      let total = 0;
      items.forEach((item) => {
        const check = item.querySelector('[data-fbt-check]');
        if (check && check.checked) total += itemPrice(item);
      });
      if (totalEl) totalEl.textContent = money(total);
    };

    scope.addEventListener('change', (e) => {
      const t = e.target;
      if (t.matches && t.matches('select[data-fbt-variant]')) {
        const item = t.closest('[data-fbt-item]');
        const priceEl = item.querySelector('[data-fbt-price]');
        if (priceEl) priceEl.textContent = money(itemPrice(item));
      }
      updateTotal();
    });

    updateTotal();

    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        const lineItems = items
          .filter((item) => {
            const c = item.querySelector('[data-fbt-check]');
            return c && c.checked;
          })
          .map((item) => ({ id: itemVariantId(item), quantity: 1 }))
          .filter((li) => li.id);

        if (!lineItems.length) return;

        addBtn.disabled = true;
        const label = addBtn.textContent;
        addBtn.textContent = 'Adding…';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: lineItems }),
          });
          if (!res.ok) throw new Error('add failed');
          window.location.href = '/cart';
        } catch (e) {
          addBtn.disabled = false;
          addBtn.textContent = label;
        }
      });
    }
  };

  // Fetch the recommendations-rendered section, then inject its content
  fetch(root.dataset.url)
    .then((r) => r.text())
    .then((text) => {
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const fetched = doc.querySelector('[data-fbt]');
      if (fetched && fetched.querySelector('[data-fbt-item]')) {
        root.innerHTML = fetched.innerHTML;
        wire(root);
      } else {
        root.remove(); // no recommendations → drop the empty section
      }
    })
    .catch(() => root.remove());
})();
